import { SearchType } from '@/types/search/SearchType.type'

export interface SearchList {
    type: SearchType
    loading: boolean
    firstLoaded: boolean
    showPerLine: number
    seeAllLink: string
    carouselOffsetVertical: string
    currentPage: number
    maxPerPage: number
    count: number
    results: Array<any>
}

export function createSearchList(
    type: SearchType,
    showPerLine: number,
    seeAllLink: string,
    carouselOffsetVertical: string
): SearchList {
    return {
        type: type,
        loading: false,
        firstLoaded: false,
        showPerLine: showPerLine,
        seeAllLink: seeAllLink,
        carouselOffsetVertical: carouselOffsetVertical,
        currentPage: 1,
        maxPerPage: showPerLine * 3,
        count: 0,
        results: [],
    }
}
